import { Slice } from "./Slice";

export { Slice as OutputConfigSlice };
